import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  getAnalyticsConsent,
  saveAnalyticsConsent,
} from "./analytics/googleAnalytics";

// Dark prompt surface (#131315), so the bright tone is the right one.
import { ACCENT } from "./theme/accent";

const CookiesMessage = () => {
  const [showMessage, setShowMessage] = useState(
    () => getAnalyticsConsent() === null
  );

  const saveChoice = (consent) => {
    saveAnalyticsConsent(consent);
    setShowMessage(false);
  };

  if (!showMessage) {
    return null;
  }

  return (
    <section
      aria-label="Analytics cookie preferences"
      className="fixed right-4 bottom-4 z-[10000] w-[min(400px,calc(100%-32px))] rounded-xl border border-[#484555] bg-[#131315] px-4 py-3 shadow-[0_16px_40px_-12px_rgba(0,0,0,0.6)]"
    >
      <p className="font-body text-[13px] leading-snug text-[#c9c4d8] m-0">
        We use optional analytics cookies to understand website traffic. Read
        our{" "}
        <Link
          to="/user/privacy/policy"
          style={{ color: ACCENT }}
          className="underline underline-offset-2 hover:opacity-70 transition-opacity"
        >
          privacy policy
        </Link>
        .
      </p>

      <div className="flex !flex-nowrap !justify-end items-center gap-2 mt-3">
        <button
          type="button"
          onClick={() => saveChoice("denied")}
          className="rounded-md border border-[#484555] bg-transparent px-3.5 py-1.5 font-headline font-semibold text-[13px] text-[#c9c4d8] hover:border-accent hover:text-accent transition-colors duration-300 active:scale-95"
        >
          Reject
        </button>
        <button
          type="button"
          onClick={() => saveChoice("granted")}
          className="rounded-md border border-accent bg-accent px-3.5 py-1.5 font-headline font-bold text-[13px] !text-accent-ink hover:bg-accent-hover transition-all duration-300 active:scale-95"
        >
          Accept analytics
        </button>
      </div>
    </section>
  );
};

export default CookiesMessage;
